/**
 * Mixin para compatibilidad con VeeValidate legacy
 * Proporciona la funcionalidad de errors.has() y errors.first()
 */
export default {
  computed: {
    errors() {
      return {
        has: (field) => {
          // Si no hay validación, retornar false
          if (!this.$v || !this.$v[field]) {
            return false;
          }
          
          // Verificar si el campo tiene errores
          return this.$v[field].$invalid && this.$v[field].$dirty;
        },
        
        first: (field) => {
          // Si no hay validación, retornar string vacío
          if (!this.$v || !this.$v[field]) {
            return '';
          }
          
          const fieldValidation = this.$v[field];
          
          // Si no hay errores, retornar string vacío
          if (!fieldValidation.$invalid || !fieldValidation.$dirty) {
            return '';
          }
          
          // Mapear errores de Vuelidate a mensajes
          if (!fieldValidation.required) {
            return 'Este campo es requerido';
          }
          if (!fieldValidation.minLength) {
            return `Mínimo ${fieldValidation.$params.minLength.min} caracteres`;
          }
          if (!fieldValidation.maxLength) {
            return `Máximo ${fieldValidation.$params.maxLength.max} caracteres`;
          }
          if (!fieldValidation.email) {
            return 'Debe ser un email válido';
          }
          if (!fieldValidation.sameAsPassword) {
            return 'Las contraseñas no coinciden';
          }
          
          return 'Campo inválido';
        },
        
        collect: (field) => {
          // Retornar array de errores para un campo
          const errors = [];
          const error = this.errors.first(field);
          if (error) {
            errors.push(error);
          }
          return errors;
        },
        
        all: () => {
          // Retornar todos los errores como objeto
          const allErrors = {};
          if (this.$v) {
            Object.keys(this.$v).forEach(field => {
              if (field !== '$invalid' && field !== '$dirty' && field !== '$error') {
                const error = this.errors.first(field);
                if (error) {
                  allErrors[field] = [error];
                }
              }
            });
          }
          return allErrors;
        }
      };
    },
    
    // Simular VeeValidate $validator para compatibilidad
    $validator() {
      return {
        validateAll: async () => {
          // Si no hay Vuelidate configurado, asumir que todo es válido
          if (!this.$v) {
            console.warn('No hay validaciones de Vuelidate configuradas');
            return true;
          }
          
          // Marcar todos los campos como "dirty" para mostrar errores
          this.$v.$touch();
          
          // Retornar el estado de validación
          return !this.$v.$invalid;
        }
      };
    }
  }
};
